import { useMutation } from '@tanstack/react-query'

import { ParkingAssignmentTypeEnum, UpdateResidentVehicle } from '@/models'
import { resetQueries } from '@/utils'

import { authAPI } from '../new-api'
import { GET_PARKING_SPOTS_BASE_QUERY_KEY } from './get-parking-spots'
import { GET_RESIDENT_VEHICLES_BASE_QUERY_KEY } from './get-resident-vehicles'

export type UpdateParkingSpotRequest =
  | { parkingSpotId: number; assignmentType: 'Unassigned' }
  | {
      parkingSpotId: number
      assignmentType: 'Unit'
      unit: string
      clientId?: number
      vehicles?: UpdateResidentVehicle[]
      confirmAssociation?: boolean
    }
  | {
      parkingSpotId: number
      assignmentType: 'Resident'
      clientId: number
      vehicles?: UpdateResidentVehicle[]
      confirmAssociation?: boolean
    }

export const updateParkingSpot = async (data: UpdateParkingSpotRequest) => {
  const { parkingSpotId, assignmentType } = data

  const body: Record<string, unknown> = {
    assignmentType,
    ...(assignmentType !== ParkingAssignmentTypeEnum.enum.Unassigned && {
      ...('unit' in data && { unit: data.unit }),
      ...('clientId' in data && { clientId: data.clientId }),
      ...(data.vehicles && { vehicles: data.vehicles }),
      ...(data.confirmAssociation != null && { confirmAssociation: data.confirmAssociation }),
    }),
  }

  const response = await authAPI.put(`/parking/${parkingSpotId}`, body)
  return response.data
}

export const useUpdateParkingSpot = () => {
  return useMutation({
    mutationFn: updateParkingSpot,
    onSuccess: async () => {
      await resetQueries([GET_PARKING_SPOTS_BASE_QUERY_KEY], [GET_RESIDENT_VEHICLES_BASE_QUERY_KEY])
    },
  })
}
